<template>

<div class="offer-badges">
    <div class="pink" v-if="badges.has('new')">Новинка</div>
    <div class="orange" v-if="badges.has('best-price')">Лучшая цена</div>
    <div class="coupon" v-if="suggestedCoupon">-{{ suggestedCoupon.v }}% по промокоду</div>
</div>

</template>

<script lang="ts" setup>
import { maxBy } from 'lodash-es';
import { useCartCouponStore } from '~/store/cartCouponStore';
import type { IOffer } from '~/types/catalog';

const props = defineProps<{
    offer: IOffer
}>();

const badges = computed(() => new Set(props.offer.badges));


const couponStore = useCartCouponStore();

const suggestedCoupon = computed(() => {
    if (!props.offer.price.discount) {
        return 0;
    }

    const availableCoupons = couponStore.availableCouponBadges
        .filter((el) => props.offer.price.discount!.type & (1 << el.i));

    if (!availableCoupons.length) {
        return 0;
    }

    return maxBy(availableCoupons, 'v');
});


</script>

<style lang="scss" scoped>

.offer-badges {

    &>* {
        padding: 4px 8px;
        height: 24px;
        text-decoration: none;
        color: white;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        width: fit-content;
        text-wrap: nowrap;
        display: flex;
        line-height: 1;
        align-items: center;
        font-size: 14px;
    }

    .pink {
        background: var(--pink);
    }
    .orange {
        background: var(--orange);
    }
    .coupon {
        background-color: #ADE4FF;
        color: #2e3d44;
    }
}

</style>